interface StatusIconProps {
  status: string | null | undefined
  showLabel?: boolean
  size?: 'sm' | 'md' | 'lg'
}

const statusConfig: Record<string, {
  label: string
  shortLabel: string
  bgColor: string
  textColor: string
  fontSize?: number
}> = {
  OK: {
    label: 'OK',
    shortLabel: 'OK',
    bgColor: '#00B050',
    textColor: '#FFFFFF',
    fontSize: 9,
  },
  C: {
    label: 'Kommentar',
    shortLabel: 'C',
    bgColor: '#5CC88C',
    textColor: '#FFFFFF',
    fontSize: 9,
  },
  NC: {
    label: 'Ikke godkjent',
    shortLabel: 'NC',
    bgColor: '#CC0000',
    textColor: '#FFFFFF',
    fontSize: 8,
  },
  EXP: {
    label: 'Utløpt',
    shortLabel: 'EXP',
    bgColor: '#BFBFBF',
    textColor: '#FFFFFF',
    fontSize: 7,
  },
  RC: {
    label: 'Anbefaling',
    shortLabel: 'RC',
    bgColor: '#FF3300',
    textColor: '#FFFFFF',
    fontSize: 8,
  },
  MO: {
    label: 'Memorandum',
    shortLabel: 'MO',
    bgColor: '#5CC88C',
    textColor: '#FFFFFF',
    fontSize: 8,
  },
  M: {
    label: 'Mangler',
    shortLabel: 'M',
    bgColor: '#FFC000',
    textColor: '#000000',
    fontSize: 9,
  },
  MISSING: {
    label: 'Mangler',
    shortLabel: '?',
    bgColor: '#808080',
    textColor: '#FFFFFF',
    fontSize: 9,
  },
  UNKNOWN: {
    label: 'Ukjent',
    shortLabel: '?',
    bgColor: '#808080',
    textColor: '#FFFFFF',
    fontSize: 9,
  },
}

const sizeConfig = {
  sm: { width: 20, height: 20, textY: 13 },
  md: { width: 24, height: 24, textY: 15.5 },
  lg: { width: 28, height: 28, textY: 18 },
}

const StatusIcon = ({ status, showLabel = false, size = 'md' }: StatusIconProps) => {
  const normalizedStatus = status?.toUpperCase() || 'UNKNOWN'
  const config = statusConfig[normalizedStatus] || statusConfig.UNKNOWN
  const dimensions = sizeConfig[size]
  const radius = dimensions.width / 2

  const baseFontSize = config.fontSize || 9
  const fontSizeScale = size === 'sm' ? 1 : size === 'md' ? 1.1 : 1.25
  const fontSize = Math.round(baseFontSize * fontSizeScale)

  const svgIcon = (
    <svg
      width={dimensions.width}
      height={dimensions.height}
      viewBox={`0 0 ${dimensions.width} ${dimensions.height}`}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={config.label}
    >
      <circle cx={radius} cy={radius} r={radius} fill={config.bgColor} />
      <text
        x={radius}
        y={dimensions.textY}
        textAnchor="middle"
        fontSize={fontSize}
        fontWeight="600"
        fill={config.textColor}
        fontFamily="Arial, Helvetica, sans-serif"
      >
        {config.shortLabel}
      </text>
    </svg>
  )

  if (showLabel) {
    return (
      <div className="inline-flex items-center gap-1.5">
        {svgIcon}
        <span className="text-xs font-semibold text-slate-700">{config.label}</span>
      </div>
    )
  }

  return (
    <div className="inline-flex items-center justify-center" title={config.label}>
      {svgIcon}
    </div>
  )
}

export default StatusIcon
